import { render, staticRenderFns } from "./BaseRouterLink.vue?vue&type=template&id=a83f8aa2&scoped=true"
var script = {}
import style0 from "./BaseRouterLink.vue?vue&type=style&index=0&id=a83f8aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83f8aa2",
  null
  
)

export default component.exports